import { Moon, Sun } from 'lucide-react';

import { useThemeMode, type ThemeMode } from './ThemeMode';

/**
 * Сегментный переключатель темы в шапке. Два «капсулы» внутри pill-контейнера,
 * с плавным «движением» подсветки между ними.
 */
const ThemeToggle = () => {
  const { mode, setMode } = useThemeMode();

  const Item = ({
    value,
    icon,
    label,
  }: {
    value: ThemeMode;
    icon: React.ReactNode;
    label: string;
  }) => {
    const active = mode === value;
    return (
      <button
        type="button"
        onClick={() => setMode(value)}
        aria-label={label}
        title={label}
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 26,
          height: 24,
          padding: 0,
          border: 'none',
          background: 'transparent',
          color: active ? 'var(--shell-accent-primary)' : 'var(--shell-text-tertiary)',
          cursor: 'pointer',
          borderRadius: 999,
          transition: 'color 120ms ease-out',
        }}
        onMouseEnter={(e) => {
          if (!active) (e.currentTarget as HTMLElement).style.color = 'var(--shell-text-secondary)';
        }}
        onMouseLeave={(e) => {
          if (!active) (e.currentTarget as HTMLElement).style.color = 'var(--shell-text-tertiary)';
        }}
      >
        {icon}
      </button>
    );
  };

  return (
    <div
      role="group"
      aria-label="Тема"
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        padding: 2,
        height: 28,
        background: 'var(--shell-bg-subtle)',
        border: '1px solid var(--shell-border-subtle)',
        borderRadius: 999,
      }}
    >
      {/* Подсветка активной кнопки */}
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 2,
          left: mode === 'light' ? 2 : 28,
          width: 26,
          height: 22,
          borderRadius: 999,
          background: 'var(--shell-bg-surface)',
          boxShadow: '0 1px 2px rgba(15,16,20,0.08)',
          transition: 'left 180ms cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
      <Item value="light" icon={<Sun size={13} strokeWidth={1.75} />} label="Светлая тема" />
      <Item value="dark" icon={<Moon size={13} strokeWidth={1.75} />} label="Тёмная тема" />
    </div>
  );
};

export default ThemeToggle;
